<div class="business-list-view col-md-12 padding-right-0 padding-left-0">
  <div class="hpanel" style="display: flex; align-items: center;">
     <label class="panel-body padding-right-10 font-size-bold " style="margin-top:6px;" title="{{values.communityName }}">{{values.communityName | truncate : 20 }}</label>
    <form class="app-form form-inline  float-r">
     
      <div class="form" style=" margin-top: 3px; margin-left: 146px;">
      <div class="form-group ">
        <div class="input-group">
          <!-- <input type="text" class="form-control" placeholder="Search Invite Members"
          [(ngModel)]="adminSreach" name="searchInvite"   (keyup)="keyupdata($event)" (keyup.enter)="onsearch(adminSreach)"[ngModelOptions]="{standalone: true}" aria-label="Amount (to the nearest dollar)">
           <span class="input-group-addon"  (click)="onsearch(adminSreach)" id="my_btn" ><ng-icon name="tablerSearch"></ng-icon></span>        -->

           <input type="text" class="form-control" placeholder="Search Invite Members"
          [(ngModel)]="searchKey" name="searchInvite"  [ngModelOptions]="{standalone: true}" aria-label="Amount (to the nearest dollar)">
           <!-- <span class="dummyBtn"></span>  -->
        </div>
      </div>

      <!-- dropdwon start -->

      <!-- class="btn btn-primary dropdown-toggle  " -->

      <div class="btn-group ml-10" dropdown container="body" >
        <button id="button-container" [disabled]="true" class="btn primary-btn"
          style="min-width: 50px !important;" aria-controls="dropdown-container" >
          <ng-icon name="tablerFilter"></ng-icon>
        </button>
        <ul id="dropdown-container" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-container">
          <!-- <li role="menuitem"><a class="dropdown-item"  >Accept </a></li>
              <li role="menuitem"><a class="dropdown-item"  >Ignore</a></li>
              <li role="menuitem"><a class="dropdown-item"  >Deny</a></li> -->
        </ul>
      </div>
      <!-- dropdwon end -->

      <!-- <button class="btn primary-btn" style="margin-left: 5px;min-width: 50px !important;" disabled>Advance
        Search</button> -->
      </div>
    </form>
  </div>
  <div >
    <div class="col-sm-12 col-md-6 col-lg-4 padding-right-5 padding-left-0" *ngFor="let data of values.invitelist | customFilter:{userName:searchKey}:false">
      <div class="hpanel  contact-panel" style="height: fit-content !important;">
        <div class="panel-body" style="height: 150px !important;cursor: pointer;" (click)="userprofile(data.userId)">
          <div class="row">
            <div class="col-sm-12">
              <div class="btn-group  pull-right m-t-m-20s">
                <div class="btn-group m-top-15">
                  <div class="kksdxm"  *ngIf="data.status=='REQUEST SEND'"> Invite sent  </div>
                  <button *ngIf="data.status=='PENDING'" type="button" class="btn primary-btn btn-xs common-font-12"
                    aria-controls="dropdown-basic" (click)="invite(data);$event.stopPropagation();">Invite
                  </button>
                </div>
              </div>
              <img alt="logo m-t-5m" (click)="userprofile(data.userId)"
                *ngIf="data.photo !=undefined && data.photo !=null || data.photo !=''" class="m-t-5m"
                src={{data.photo}}>
              <img alt="logo m-t-5m" (click)="userprofile(data.userId)" class="m-t-5m"
                *ngIf="data.photo==undefined || data.photo==null || data.photo==''" src="assets/images/userAvatar.png">
              <div class="ellipse ooep" (click)="userprofile(data.userId)"
                data-toggle="tooltip" data-placement="top" title="{{data.userName}}">{{data.userName }} </div>
              <div class="text-muted m-b-xs ellipse" data-toggle="tooltip" data-placement="top"
                title="{{data.title}}">{{data.title }}</div>
              <p data-toggle="tooltip" class="ellipse" data-placement="top" title="{{data.organisation}}">
                {{data.organisation}}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="iiiei">
        <div class="s1s">
          <div class="eerr"> CONNECTIONS</div>
          <div class="sfkp">{{data.connectionCnt}}</div>
          </div>
        <div class="s2s">
          <div class="eerr1">POSTS</div>
          <div class="lgho">{{data.postCnt}}</div>
          </div>
      </div>
    </div>

    <div class="col-md-12 pad" *ngIf="values?.invitelist?.length==0 && showNoDatafound">
      <app-nodata-found [title]="noDatafound" ></app-nodata-found>
    </div>
  </div>
</div>
